import dayjs from 'dayjs';
import { Locales } from '../context/Localization/localization.types';

export const formatForServer = (date: dayjs.Dayjs | Date) => dayjs(date)
    .format('YYYY-MM-DDTHH:mm:ss.SSSZ');

export const convertHoursTimeString = (time: string, locale: Locales) => dayjs(time, 'HH:mm:ss')
    .format(locale !== Locales.fr ? 'h:mm A' : 'H [h] mm');